<div class="card">

    <div class="card-body">
            
        <p>Si quieres obtener información acerca de nuestros cursos, no dudes en preguntarnos lo que quieras:</p>

        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <mat-form-field class="custom-contact-form-mat-input-element w-100" appearance="outline">
                    <mat-label>Nombre</mat-label>
					<input matInput type="text" [formControl]="nameFormControl" autocomplete="off" required>
					<mat-error *ngIf="nameFormControl.errors?.required">Introduzca un nombre.</mat-error>
				</mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
				<mat-form-field class="custom-contact-form-mat-input-element w-100" appearance="outline">
                    <mat-label>Correo electrónico</mat-label>
					<input matInput type="email" [formControl]="mailFormControl" autocomplete="off" required>
					<mat-error *ngIf="mailFormControl.errors?.required">Introduzca una dirección de correo electrónico.</mat-error>
					<mat-error *ngIf="mailFormControl.errors?.email">Introduzca una dirección de correo electrónico válida.</mat-error>
				</mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <mat-form-field class="custom-contact-form-mat-input-element w-100" appearance="outline">
                    <mat-label>Mensaje</mat-label>
					<textarea matInput type="text" autocomplete="off" required
                        [formControl]="messageFormControl" 
                        [matTextareaAutosize]="true" 
                        [matAutosizeMinRows]="5" 
                        [matAutosizeMaxRows]="10">
                    </textarea>
					<mat-error *ngIf="messageFormControl.errors?.required">Introduzca un mensaje.</mat-error>
				</mat-form-field>
            </div>
        </div>

        <div class="row">
            
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <mat-checkbox class="w-100 d-flex flex-row justify-content-start align-items-start mb-2"
                    [checked]="lopdChecked"
                    (change)="lopdChecked = !lopdChecked">
                    <span class="text-wrap" [innerHTML]="authorization"></span>
                </mat-checkbox>
                <div class="alert alert-info" role="alert">
                    <h6 class="fw-bold">CUMPLIMIENTO LEY ORGÁNICA PROTECCIÓN DE DATOS</h6>
                    <span [innerHTML]="lopd"></span>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 d-grid">
                <button mat-raised-button class="custom-contact-form-button btn py-2 px-4" 
                    [disabled]="!lopdChecked || nameFormControl.invalid || mailFormControl.invalid || messageFormControl.invalid"
                    (click)="sendContactForm()">
                    <span class="material-icons">send</span>
                    <span class="ms-2">Enviar</span>
                </button>
            </div>

        </div>

    </div>

</div>